import { render, staticRenderFns } from "./ApiTestpage.vue?vue&type=template&id=51882fa3&scoped=true&"
import script from "./ApiTestpage.vue?vue&type=script&lang=ts&"
export * from "./ApiTestpage.vue?vue&type=script&lang=ts&"
import style0 from "./ApiTestpage.vue?vue&type=style&index=0&id=51882fa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51882fa3",
  null
  
)

export default component.exports